







































































































import {Component, Vue} from "vue-property-decorator";
import CompanyService from "@/services/CompanyService";
import BusinessTaxReturnDTO from "@/dto/taxation/business/BusinessTaxReturnDTO";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import BusinessTaxReturnModal from "@/components/profile/taxation/BusinessTaxReturnModal.vue";
import SubmissionIdModal from "@/components/profile/taxation/SubmissionIdModal.vue";
import {namespace} from "vuex-class";
import PortalCheckbox from "@/components/new_style_components/PortalCheckbox.vue";
import PortalSelect from "@/components/new_style_components/PortalSelect.vue";
import PortalInput from "@/components/new_style_components/PortalInput.vue";
import SelectOption, {OptionsBuilder} from "@/components/common/SelectOption";
import {debounce} from "typescript-debounce-decorator";

const AppModule = namespace("App");

@Component({
    components: {
        PaginationComponent,
        PortalCheckbox,
        PortalSelect,
        PortalInput,
    }
})
export default class BusinessTaxReturns extends Vue {
    private data: BusinessTaxReturnDTO[] = [];
    private totalPages = 0;

    private filter = {
        pageNumber: 1,
        pageSize: 40,
        type: null as string | null,
        hasNoSubmissionId: false,
        period: null as string | null,
        companyName: null as string | null,
    };

    @AppModule.Action
    private startLoading!: () => void;

    @AppModule.Action
    private stopLoading!: () => void;

    get btrTypeOptions(): Array<SelectOption> {
        return OptionsBuilder.of("All Types", null)
            .of("FEDERAL", "FEDERAL")
            .of("STATE", "STATE")
            .of("CITY", "CITY")
            .get();
    }

    get periodOptions(): Array<SelectOption> {
        const currentYear = new Date().getFullYear();
        let builder = OptionsBuilder.of("All Periods", null);
        for (let y = currentYear; y >= 2019; y--) {
            builder = builder.of(String(y), String(y));
        }
        return builder.get();
    }

    mounted() {
        this.loadData();
    }

    @debounce(500)
    async loadData(page = 1) {
        this.filter.pageNumber = page;
        this.startLoading();
        try {
            const res = await CompanyService.getAllBusinessTaxReturnsPaginated(
                this.filter.pageNumber,
                this.filter.pageSize,
                this.filter.type,
                this.filter.hasNoSubmissionId,
                this.filter.period,
                this.filter.companyName,
            );
            this.data = res.data.content;
            this.totalPages = res.data.totalPages as number;
        } catch (err) {
            console.error("Error loading BTR data:", err);
        } finally {
            this.stopLoading();
        }
    }

    openUploadModal() {
        this.$modal.show(
            BusinessTaxReturnModal,
            {
                onSave: () => this.loadData(1)
            }
        );
    }

    openEditModal(btr: BusinessTaxReturnDTO) {
        this.$modal.show(
            SubmissionIdModal,
            {
                id: btr.id,
                onSave: () => this.loadData(this.filter.pageNumber)
            }
        );
    }

    clearFilters() {
        this.filter.pageNumber = 1;
        this.filter.type = null;
        this.filter.hasNoSubmissionId = false;
        this.filter.period = null;
        this.filter.companyName = null;
        this.loadData(1);
    }
}
